<template>
    <ViewEmailSetting :configKey="$route.params.emailTemplate" :showOtherTemplatesButton="showOtherTemplatesButton" />
</template>


<script>
import ViewEmailSetting from '@/views/admin/settings/email/ViewEmailSetting.vue';

export default {
    name: 'DynamicEmailTemplateEditor',
    props: {
        showOtherTemplatesButton: Boolean,
    },
    components: { ViewEmailSetting },
};
</script>


<style lang='scss' scoped></style>